import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

const ProtectedRoute = ({
  requiredRole,       // e.g. "host", "author", "reviewer"
  redirectTo = '/'
}) => {
  const token = localStorage.getItem('token');
  const roleId = {
    admin: localStorage.getItem("adminID"),
    host: localStorage.getItem('HostID'),
    author: localStorage.getItem('AuthorID'),
    reviewer: localStorage.getItem('reviewerID'),
  }[requiredRole];

  const location = useLocation();

  if (!token || !roleId) {
    // Not authenticated or wrong role
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
